import parse from 'html-react-parser'; /* {parse(str)}  */
import * as React from 'react';
import { Alert, Col, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { ErrorGrid, getSupplementalGridErrorList } from '../../redux/ValidationSlice';


const ShowSupplementalGridErrorList = () => {

    /* ************************************** Redux ********************************************/
    const dispatch = useAppDispatch();
    /* ************************************** Modal section ************************************/


    const rowErrorList: Array<ErrorGrid> = useAppSelector(getSupplementalGridErrorList);

    const createErrorListHtml = function (eList: ErrorGrid[]) : string {
        if (!(eList) || eList.length === 0) {
            return "<div></div>";
        }

        var html = "<ul>";
        for (var e of rowErrorList) {
            html = html + "<li>" + e.message + "</li>";
        }
        html = html + "</ul>";
        return html;
    }
    const [html, setHtml] = React.useState<string>(createErrorListHtml(rowErrorList));

    React.useEffect(() => {
        setHtml(createErrorListHtml(rowErrorList));
    }, [rowErrorList])
    const notifyErrors = function () {

        if (!(rowErrorList) || rowErrorList.length === 0) {
            return <div></div>;
        }

        return (
            <div>
                <Alert color="warning" className="errorListForGridComponents">
                    <p>Error list</p>
                    {parse(html)}
                </Alert>
            </div>
        )
    }

    return (
        <>
            <Row>
                <Col>
                    {notifyErrors()}
                </Col>
            </Row>
            
        </>


    );
}


export { ShowSupplementalGridErrorList };
